exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Quote-module__quote___1b3jn{display:grid;justify-content:center;align-items:center;padding:10%}.Quote-module__quote___1b3jn div{display:flex;flex-direction:column;gap:16px}.Quote-module__quote___1b3jn h2{font-size:26px;text-transform:capitalize;line-height:1.1}.Quote-module__quote___1b3jn h2,.Quote-module__quote___1b3jn p{text-align:center}", ""]);

// exports
exports.locals = {
	"quote": "Quote-module__quote___1b3jn"
};